export default __webpack_public_path__ + "static/gma-logo-dark-144ec8ed5a64aa93dd4cd0bf9afdcaca.svg";